<template>
  <div>
    <TemplateCouponDetail v-if="isReadyToDraw" />

    <!-- 描画ローディング -->
    <DialogInitialLoading v-else />

    <!-- なんらかが原因でURLが不正なページへのアクセスが発生した場合のダイアログ -->
    <DialogInvalidPageAccess ref="DialogInvalidPageAccess" />
  </div>
</template>

<script>
// Vue
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

// Vueファイル
import TemplateCouponDetail from "@/views/Templates/MyCoupons/TemplateCouponDetail";
import DialogInvalidPageAccess from "@/views/Components/Organisms/TicketStore/Dialog/DialogInvalidPageAccess";

// Service
import nativeHandlerService from "@/services/nativeHandler";

// API
import API from "@/API";

export default {
  name: "CouponDetailIndex",
  components: {
    TemplateCouponDetail: TemplateCouponDetail,
    DialogInvalidPageAccess: DialogInvalidPageAccess,
  },

  setup() {
    const store = useStore();
    const route = useRoute();

    const isReadyToDraw = ref(false);
    const DialogInvalidPageAccess = ref(null);

    onMounted(async () => {
      try {
        await API.getExternalCoupon(route.params.id);
        await API.getMasterCoupon();

        isReadyToDraw.value = true;
      } catch (err) {
        nativeHandlerService.ncSendTicketingError(
          "Coupon onMounted()",
          JSON.stringify(err)
        );
        // 認証エラーの場合
        if (
          !err.response ||
          err.response.data.error == "internal_error" ||
          err.response.data.error == "parameter_error"
        ) {
          nativeHandlerService.returnNativeAppToAccountPage();
          // ダイアログを閉じたときのために、5秒後に一覧にリダイレクト
          setTimeout(() => {
            nativeHandlerService.returnNativeAppTopPage();
          }, 5000);
          return;
        }
        // 本番環境で端末時刻が不正の場合は、ネイティブで別途ダイアログ出す
        else if (err != "invalid client DateTime") {
          openDialogInvalidPageAccess();
        }
        console.log("error in MasterBook", err);
      }
    });

    const coupon = computed(() => store.getters["coupon/externalCoupon"]);
    const masterCoupon = computed(() => store.getters["coupon/masterCoupon"]);

    // URL不正の場合のダイアログ
    const openDialogInvalidPageAccess = () => {
      DialogInvalidPageAccess.value.openDialog();
    };

    return {
      isReadyToDraw,
      coupon,
      masterCoupon,
      DialogInvalidPageAccess,
    };
  },
};
</script>
